import React, { FC } from "react";
import { Modal } from "react-bootstrap";
import "../../../../../core/components/modal/modal.scss";

interface ModalComponentProps {
  showModal: boolean;
  handleClose: () => void;
  size?: "sm" | "lg" | "xl";
  children: React.ReactNode;
  subHeader?: string;
}

const AssetUploadModal: FC<ModalComponentProps> = ({
  showModal,
  handleClose,
  size = "xl",
  children,
  subHeader,
}) => {
  return (
    <Modal show={showModal} onHide={handleClose} size={size} backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>
          <div className="ps-5 pt-5">Asset Upload Response</div>
          {subHeader && (
            <div className="ps-5 text-muted fs-6">{subHeader}</div>
          )}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="ps-5 pe-5">{children}</div>
      </Modal.Body>
    </Modal>
  );
};

export default AssetUploadModal;
